import { render } from "./StatisticsComponent.vue?vue&type=template&id=2d9af051&scoped=true"
import script from "./StatisticsComponent.vue?vue&type=script&lang=js"
export * from "./StatisticsComponent.vue?vue&type=script&lang=js"

import "./StatisticsComponent.vue?vue&type=style&index=0&id=2d9af051&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9af051"]])

export default __exports__